
import resources from '../resources.json'

export const resources_by_name = {}
export const resources_map = {}
resources.resources.forEach(function(r) { resources_by_name[r['name']] = r})
resources.resources.forEach(function(r) { if(r.server_name) { resources_map[r.name] = r.server_name}})
